export const routes = (prefix = `billing`, pref = `consultant-dashboard`) => [
    {
        path: `/${prefix}/${pref}/payment/view`,
        name: `${prefix}.${pref}.payment.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.payment.view`,
                PageDescription: "Consultant Payment: View Payments",
            },
        },
    },
    {
        path: `/${prefix}/${pref}/payment/print`,
        name: `${prefix}.${pref}.payment.print`,
        component: () => import('./prints/PaymentDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.payment.view`,
                PageDescription: "Consultant Payment: View Payments",
            },
        },
    },
    {
        path: `/${prefix}/${pref}/payment/consultant-payments/print`,
        name: `${prefix}.${pref}.payment.consultant-payments.print`,
        component: () => import('./prints/ConsultantPayments.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.payment.view`,
                PageDescription: "Consultant Payment: View Payments",
            },
        },
    },
];
